module.exports = __webpack_public_path__ + "img/Loginbonus_m.0d45c4db.png";